import Request from './request'

const SimServer = {
  getSimServers(callback) {
    Request.get('sim-server/index').then(callback).catch(this.bad_answer)
  },
  getRemoteSims(callback) {
    Request.get('sim-server/simcards').then(callback).catch(this.bad_answer)
  },
  
}
export default SimServer
